import request from '@/utils/request'
import { v2Host } from '@/config/host'

// key 列表：dmaker.template.info,dmaker.template.save

/**
 * getDmakerCustomInfo
 * http://playable.dev.com:8067/?doc=dmaker/template.go#%2fdmaker%2ftemplate%2finfo
 * @param {{template_id: number}} params
 */
export function getDmakerTemplateInfo(params) {
  return request({
    url: `${v2Host}/dmaker/template/info`,
    method: 'get',
    params: params,
  })
}

/**
 * getDmakerBasicPackageInfo 获取基础包信息
 * @param {{basic_id: number}} params
 */
export function getDmakerBasicPackageInfo(params) {
  return request({
    url: `${v2Host}/dmaker/template/basic-tpl-info`,
    method: 'get',
    params,
  })
}

/**
 * 创意模板保存&打包
 * http://playable.dev.com:8067/?doc=dmaker/template.go#%2fdmaker%2ftemplate%2fsave
 * @param {{template_id: number}} params
 * @param {{json_config?: string, category_config?: string, resource_config?: string, dco_config?: string, allow_add_language?: number, stars_config?: string, pack_json_config?: string}, withoutError: boolean} data
 */
export function saveDmakerTemplate(params, data, withoutError) {
  return request({
    url: `${v2Host}/dmaker/template/save`,
    method: 'post',
    data,
    params,
    withoutError: withoutError,
  })
}

export function getDmakerDcoDetail(params) {
  return request({
    url: `${v2Host}/dmaker/template/dco-detail`,
    method: 'get',
    params: params,
  })
}

/**
 * resetDmakerTemplate
 * @param template_id {number}
 * @param all {number} 1 重置所有内容，2 重置 json
 * @returns {AxiosPromise}
 */
// eslint-disable-next-line camelcase
export function resetDmakerTemplate({ template_id, all }) {
  return request({
    url: `${v2Host}/dmaker/template/reset`,
    method: 'post',
    params: {
      template_id,
      all,
    },
  })
}

/**
 * preview 预览模板
 * @param {{id: string|number, lang: string}} params
 */
export function previewDmakerTemplate(params, config) {
  return request({
    url: `${v2Host}/dmaker/template/preview`,
    method: 'get',
    params,
    ...config,
  })
}

/**
 * getDmakerTemplateOriginalInfo 获取初始化 json 数据
 * @param {{id: string|number, type: number}} params
 */
export function getDmakerTemplateOriginalInfo(params) {
  return request({
    url: `${v2Host}/dmaker/template/init-json`,
    method: 'get',
    params,
  })
}

export function getDmakerImage(imgUrl) {
  return request({
    url: `${v2Host}/openapi/dmaker/image`,
    method: 'get',
    params: {
      url: imgUrl,
    },
  })
}

// 激活创意方向
export function activeDmakerTemplate(id) {
  return request({
    url: `${v2Host}/dmaker/template/active`,
    method: 'post',
    params: {
      id,
    },
  })
}
